import { ValidationError } from "yup"
import { assert } from "../../../../Helpers/logging"

/**
 * @memberof useValidateSchema
 * */
export const validationMessages = (error: ValidationError): ValidationError[] => {
    assert(
        error instanceof ValidationError && !!error.inner,
        `${error.message} not instanceof Yup's ValidationError`
    )
    return error.inner
}
